export default "__VITE_ASSET__BeO2kapb__"